import PropTypes from 'prop-types';
import { Formik } from 'formik';

const defaultProps = {};

const propTypes = {
  children: PropTypes.func.isRequired,
};

export default function Form({
  children,
  ...props
}) {
  return (
    <Formik {...props}>
      {(formik) => (
        <form className="flex w-full" onSubmit={formik.handleSubmit}>
          {children(formik)}
        </form>
      )}
    </Formik>
  );
}

Form.defaultProps = defaultProps;
Form.propTypes = propTypes;
